import { useIntl } from 'react-intl'
import LineBathIcon from 'LuxKit/Icons/line/LineBathIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { rem } from 'polished'
import styled from 'styled-components'

export const OfferCardCapacityGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: ${rem(12)};
  padding: ${rem(8)} 0;
`

interface Props {
  guests?: number
  bedrooms?: number
  bathrooms?: number
}

function OfferCardCapacityItems(props: Props) {
  const { guests, bedrooms, bathrooms } = props
  const intl = useIntl()

  return <>
    {!!guests && <BodyTextBlock variant="medium" colour="light-foreground-alt" startIcon={<LineUsersAltIcon />}>
      {intl.formatMessage(
        {
          id: '0w2PfdE_-rGvbwotjhU5',
          defaultMessage: '{count, plural, one {# guest} other {# guests}}',
          description: 'Guest capacity count on villa search card in the search interface',
        },
        { count: guests },
      )}
    </BodyTextBlock>}
    {!!bedrooms && <BodyTextBlock variant="medium" colour="light-foreground-alt" startIcon={<LineBedIcon />}>
      {intl.formatMessage(
        {
          id: 'OzjFoGgYRzkMYjmUlmgP',
          defaultMessage: '{count, plural, one {# bedroom} other {# bedrooms}}',
          description: 'Bedroom count on villa search card on the hotel or room booking page',
        },
        { count: bedrooms },
      )}
    </BodyTextBlock>}
    {!!bathrooms && <BodyTextBlock variant="medium" colour="light-foreground-alt" startIcon={<LineBathIcon />}>
      {intl.formatMessage(
        {
          id: 'cIF-oQUPkYGHxeub3f6s',
          defaultMessage: '{count, plural, one {# bathroom} other {# bathrooms}}',
          description: 'Bathroom count on villa search card on the hotel or room booking page',
        },
        { count: bathrooms },
      )}
    </BodyTextBlock>}
  </>
}

export default OfferCardCapacityItems
